import React from "react";
import { Route, Routes } from "react-router-dom";

// screens
import MainScreen from "../Views/MainScreen/MainScreen";
// import WorkInProgress from "../Views/Common/work-in-progress";
import NotFound404 from "../Views/Common/not-found-404";
import DashboardScreen from "../Views/MainScreen/DashboardScreen/DashboardScreen";
import ProfileScreen from "../Views/MainScreen/ProfileScreen/ProfileScreen";
import TransactionsScreen from "../Views/MainScreen/TransactionsScreen/TransactionsScreen";
import AgentScreen from "../Views/MainScreen/AgentScreen/AgentScreen";
import HeadOfficeDashboardScreen from "../Views/HeadOffice/DashboardScreen/HeadOfficeDashboardScreen";
import OfficesScreen from "../Views/HeadOffice/UsersScreen/OfficesScreen";
import FeSummaryPage from "../Views/MainScreen/SummaryScreen/FeSummaryPage";
import TransactionsScreenHeadOffice from "../Views/MainScreen/TransactionsScreen/TransactionsScreenHeadOffice";
import SettingScreen from "../Views/MainScreen/SettingScreen/SettingScreen";
import TransactionLogsScreen from "../Views/HeadOffice/TransactionLogsScreen/TransactionLogsScreen";

export function OfficeNavigator(props) {
  return (
    <MainScreen {...props}>
      <Routes>
        <Route path="/" element={<TransactionsScreen />} />
        <Route path="/transaction" element={<TransactionsScreen />} />

        <Route path="/summary" element={<FeSummaryPage />} />
        <Route path="/fe" element={<AgentScreen />} />

        <Route path="/profile" element={<ProfileScreen />} />

        <Route path="*" element={<NotFound404 />} />
      </Routes>
    </MainScreen>
  );
}

export function HeadOfficeNavigator(props) {
  return (
    <MainScreen {...props}>
      <Routes>
        <Route path="/" element={<HeadOfficeDashboardScreen />} />
        <Route path="/offices" element={<OfficesScreen />} />
        <Route path="/transaction" element={<TransactionsScreenHeadOffice />} />
        <Route path="/trlog" element={<TransactionLogsScreen />} />

        <Route path="/profile" element={<ProfileScreen />} />
        <Route path="/setting" element={<SettingScreen />} />

        <Route path="*" element={<NotFound404 />} />
      </Routes>
    </MainScreen>
  );
}
